import React, { Component } from 'react';
import Button from './BasicLink';
import BounceLoader from './BounceLoader';

const ToggleExpandButton = ({ onClick, expanded, track }) => (
  <div className="text-center">
    <Button
      buttonStyle="basic"
      onClick={onClick}
      track={{ ...track, action: `View${expanded ? 'Less' : 'More'}` }}
      className={`with-icon-before icon-navigate${expanded ? 'up' : 'down'}`}
      external
    >
      <span>{expanded ? 'View less' : 'View more'}</span>
    </Button>
  </div>
);

class ExpandableContent extends Component {
  state = { expanded: false }

  toggleExpand = () => {
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    const { items, initialItems, track } = this.props;
    const { expanded } = this.state;

    if (items && items.length) {
      const visibleItems = expanded ? items : items.slice(0, initialItems);
      return (
        <div>
          {visibleItems}
          <ToggleExpandButton onClick={this.toggleExpand} expanded={expanded} track={track} />
        </div>
      );
    }

    return <BounceLoader />;
  }
}

export default ExpandableContent;



// WEBPACK FOOTER //
// ./src/universal/ui/components/ExpandableContent.js